import { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Chip,
    ClickAwayListener,
    Divider,
    Grid,
    InputAdornment,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    OutlinedInput,
    Paper,
    Popper,
    Stack,
    Switch,
    Typography
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import axios from 'axios';
import envVariables from 'environment.js';
import Snackbars from 'ui-component/components/Snackbars';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import UpgradePlanCard from './UpgradePlanCard';
// import User1 from 'assets/images/users/user-round.svg';
import User1 from 'assets/images/users/school-logo2.svg';
import AuthHeader from 'services/authHeader';

// assets
import { IconLogout, IconLogin, IconSearch, IconSettings, IconUser, IconCurrencyRupee } from '@tabler/icons';
// import { IconCoinRupee } from '@tabler/icons';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const [sdm, setSdm] = useState(true);
    const [value, setValue] = useState('');
    const [notification, setNotification] = useState(false);
    const [classInfo, setclassInfo] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('loggedUser')));
    const [snackbarprops, setsnackbarprops] = useState({ content: '', color: '' });
    // var classInfo = [];
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);
    const childRefSnackbar = useRef(null);
    const handleClickEvent = async () => {
        if (user == null) {
            // console.log('Login');
            navigate('/login');
        }
        if (user != null) {
            // console.log('Logout');
            // setUser(null);
            getLoggedOut();
        }

        async function getLoggedOut() {
            // for admin & teacher
            if (user.role == 'admin' || user.role == 'teacher') {
                await axios
                    .post(`${envVariables.baseURL}logout/staff/?id=${user._id}`)
                    .then((res) => {
                        // console.log(res);
                        localStorage.removeItem('loggedUser');
                        navigate('/');
                    })
                    .catch((error) => {
                        // console.log(error);
                    });
            }
            // for student
            if (user.role == 'student') {
                await axios
                    .post(`${envVariables.baseURL}logout/${user._id}`)
                    .then((res) => {
                        // console.log(res);
                        localStorage.removeItem('loggedUser');
                        navigate('/');
                    })
                    .catch((error) => {
                        // console.log(error);
                    });
            }
        }
    };
    const handleSubscriptionEvent = async (event) => {
        if (user.role == 'student') {
            // console.log('Login');
            handleClose(event);
            navigate('/student-subscription');
        }
    };

    async function callSnackbar() {
        await childRefSnackbar.current.showSnackbar();
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);
    async function fetchClasslist() {
        await axios
            .get(`${envVariables.baseURL}get/classlist`, { headers: AuthHeader.headers })
            .then((res) => {
                const tempClassInfo = res.data.data.filter((data) => data._id == user.className);
                if (tempClassInfo.length > 0) {
                    setclassInfo(tempClassInfo);
                    const UpdateloggedUser = JSON.parse(localStorage.getItem('loggedUser'));
                    UpdateloggedUser.standard = tempClassInfo[0].class;
                    localStorage.setItem('loggedUser', JSON.stringify(UpdateloggedUser));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchClasslist();
    }, []);

    return (
        <>
            <Snackbars snackbarprops={snackbarprops} ref={childRefSnackbar} />
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: theme.palette.primary.light,
                    backgroundColor: theme.palette.primary.light,
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: theme.palette.primary.main,
                        background: `${theme.palette.primary.main}!important`,
                        color: theme.palette.primary.light,
                        '& svg': {
                            stroke: theme.palette.primary.light
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        src={User1}
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 0 8px 8px !important',
                            cursor: 'pointer'
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                    />
                }
                label={<IconSettings stroke={1.5} size="1.5rem" color={theme.palette.primary.main} />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
            />
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ px: 2, pt: 2 }}>
                                        <Stack>
                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                <Typography variant="h4">Good Morning,</Typography>
                                                <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                                                    {user != null ? user.firstName + ' ' + user.lastName : null}
                                                </Typography>
                                            </Stack>
                                            <Typography variant="subtitle2" sx={{ textTransform: 'capitalize' }}>
                                                {user != null && user.className && classInfo.length > 0 && classInfo != undefined
                                                    ? 'Class ' + classInfo[0].class
                                                    : null}{' '}
                                                {user != null ? user.role : null}
                                            </Typography>
                                        </Stack>
                                        {/* <OutlinedInput
                                            sx={{ width: '100%', pr: 1, pl: 2, my: 2 }}
                                            id="input-search-profile"
                                            value={value}
                                            onChange={(e) => setValue(e.target.value)}
                                            placeholder="Search profile options"
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                                                </InputAdornment>
                                            }
                                            aria-describedby="search-helper-text"
                                            inputProps={{
                                                'aria-label': 'weight'
                                            }}
                                        /> */}
                                        {/* <Divider /> */}
                                    </Box>
                                    <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                                        <Box sx={{ px: 2 }}>
                                            <UpgradePlanCard />
                                            <Divider />
                                            {/* <Card
                                                sx={{
                                                    bgcolor: theme.palette.primary.light,
                                                    my: 2
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid container spacing={3} direction="column">
                                                        <Grid item>
                                                            <Grid item container alignItems="center" justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="subtitle1">Start DND Mode</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Switch
                                                                        color="primary"
                                                                        checked={sdm}
                                                                        onChange={(e) => setSdm(e.target.checked)}
                                                                        name="sdm"
                                                                        size="small"
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item>
                                                            <Grid item container alignItems="center" justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="subtitle1">Allow Notifications</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Switch
                                                                        checked={notification}
                                                                        onChange={(e) => setNotification(e.target.checked)}
                                                                        name="sdm"
                                                                        size="small"
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                            <Divider /> */}
                                            <List
                                                component="nav"
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 350,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: '10px',
                                                    [theme.breakpoints.down('md')]: {
                                                        minWidth: '100%'
                                                    },
                                                    '& .MuiListItemButton-root': {
                                                        mt: 0.5
                                                    }
                                                }}
                                            >
                                                {/* <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 0}
                                                    onClick={(event) => handleListItemClick(event, 0, '/user/account-profile/profile1')}
                                                >
                                                    <ListItemIcon>
                                                        <IconSettings stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Account Settings</Typography>} />
                                                </ListItemButton> */}
                                                {/* <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 1}
                                                    onClick={(event) => handleListItemClick(event, 1, '/user/social-profile/posts')}
                                                >
                                                    <ListItemIcon>
                                                        <IconUser stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Grid container spacing={1} justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="body2">Social Profile</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Chip
                                                                        label="02"
                                                                        size="small"
                                                                        sx={{
                                                                            bgcolor: theme.palette.warning.dark,
                                                                            color: theme.palette.background.default
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                    />
                                                </ListItemButton> */}
                                                {user != null && user.role == 'student' ? (
                                                    <ListItemButton
                                                        sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                        selected={selectedIndex === 3}
                                                        onClick={handleSubscriptionEvent}
                                                    >
                                                        <ListItemIcon>
                                                            {user.role == 'student' ? (
                                                                <IconCurrencyRupee stroke={1.5} size="1.3rem" />
                                                            ) : null}
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <Typography variant="body2" component="div">
                                                                    <Typography variant="body2" component="div">
                                                                        {user.role == 'student' ? (
                                                                            <Typography variant="body2" component="div">
                                                                                <Link
                                                                                    to="/login"
                                                                                    style={{
                                                                                        textDecoration: 'none',
                                                                                        color: '#616161'
                                                                                    }}
                                                                                >
                                                                                    Buy Subscription
                                                                                </Link>
                                                                            </Typography>
                                                                        ) : null}
                                                                    </Typography>
                                                                </Typography>
                                                            }
                                                        />
                                                    </ListItemButton>
                                                ) : null}
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 4}
                                                    onClick={handleClickEvent}
                                                >
                                                    <ListItemIcon>
                                                        {user == null ? (
                                                            <IconLogin stroke={1.5} size="1.3rem" />
                                                        ) : (
                                                            <IconLogout stroke={1.5} size="1.3rem" />
                                                        )}
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body2" component="div">
                                                                <Typography variant="body2" component="div">
                                                                    {user == null ? (
                                                                        <Typography variant="body2" component="div">
                                                                            <Link
                                                                                to="/login"
                                                                                style={{
                                                                                    textDecoration: 'none',
                                                                                    color: '#616161'
                                                                                }}
                                                                            >
                                                                                Login
                                                                            </Link>
                                                                        </Typography>
                                                                    ) : (
                                                                        <Typography variant="body2" component="div">
                                                                            Logout
                                                                        </Typography>
                                                                    )}
                                                                </Typography>
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItemButton>
                                            </List>
                                        </Box>
                                    </PerfectScrollbar>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>
        </>
    );
};

export default ProfileSection;
